<template>
  <hel-module title="KPI关键指标" :class="scope.clsPrefix">
    <div class="indicators-container">
      <div class="indicator-item" v-for="(item, index) in indicators" :key="index">
        <div class="indicator-header">
          <span class="indicator-name">{{ item.name }}</span>
          <span :class="['indicator-trend', item.trendClass]">
            <span class="trend-value">{{ item.trendValue }}</span>
            <span class="trend-icon">{{ item.trendIcon }}</span>
          </span>
        </div>
        <div class="indicator-value">
          <span class="value-num">{{ item.value }}</span>
          <span class="value-unit">{{ item.unit }}</span>
        </div>
      </div>
    </div>
  </hel-module>
</template>

<script>
import HelModule from './common/module/index.vue'
import axios from 'axios'
export default {
  name: 'KpiIndicators',
  components: {
    HelModule
  },
  props: {
    data: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      scope: {
        clsPrefix: 'rvc-cosmoplat-workspace-kpi-indicators'
      },
      indicators: [
        { name: '营收达成率', value: '', unit: '%', trendValue: '', trendClass: '', trendIcon: '' },
        { name: '净利润率', value: '', unit: '%', trendValue: '', trendClass: '', trendIcon: '' },
        { name: '订单量', value: '', unit: '', trendValue: '', trendClass: '', trendIcon: '' },
        { name: '客单价', value: '', unit: '', trendValue: '', trendClass: '', trendIcon: '' }
      ]
    }
  },
  created() {},
  mounted() {
    this.fetchKpiMetrics()
  },
  methods: {
    formatValue(value, indicatorName) {
      if (indicatorName === '订单量') {
        return Math.round(value).toLocaleString()
      }
      if (indicatorName === '营收达成率' || indicatorName === '净利润率') {
        return value.toFixed(1)
      }
      if (value >= 10000) {
        return (value / 10000).toFixed(1)
      }
      return value.toFixed(1)
    },
    getUnit(value, indicatorName) {
      if (indicatorName === '营收达成率' || indicatorName === '净利润率') {
        return '%'
      }
      if (indicatorName === '订单量') {
        return ''
      }
      if (value >= 10000) {
        return '万'
      }
      return ''
    },
    getTrendInfo(growthRate) {
      if (growthRate > 0) {
        return {
          trendValue: `+${growthRate.toFixed(1)}%`,
          trendClass: 'trend-up',
          trendIcon: '↑'
        }
      } else if (growthRate < 0) {
        return {
          trendValue: `${growthRate.toFixed(1)}%`,
          trendClass: 'trend-down',
          trendIcon: '↓'
        }
      } else {
        return {
          trendValue: '0.0%',
          trendClass: 'trend-flat',
          trendIcon: '→'
        }
      }
    },
    async fetchKpiMetrics() {
      try {
        const now = new Date()
        const year = now.getFullYear().toString()
        const month = (now.getMonth()).toString()

        const response = await axios.post(
          'https://bigdata-cloud.cosmoplat.com/prod-api/system/api/call/kpiMetrics',
          {
            secret: '9k0NVP',
            paramList: [
              { paramName: 'year', paramValue: year },
              { paramName: 'month', paramValue: month }
            ]
          },
          {
            headers: {
              'Content-Type': 'application/json'
            }
          }
        )

        console.log('KPI关键指标接口返回:', response.data)

        if (response.data.code === 200 && response.data.data.length > 0) {
          const data = response.data.data[0]
          const fields = [
            'revenue_achievement_rate',
            'revenue_achievement_rate_growth_rate',
            'net_profit_margin',
            'net_profit_margin_growth_rate',
            'order_volume',
            'order_volume_growth_rate',
            'average_order_value',
            'average_order_value_growth_rate'
          ]

          this.indicators.forEach((indicator, index) => {
            const valueIndex = index * 2
            const trendIndex = index * 2 + 1

            if (valueIndex < fields.length) {
              const value = data[fields[valueIndex]]
              indicator.value = this.formatValue(value, indicator.name)
              indicator.unit = this.getUnit(value, indicator.name)
            }

            if (trendIndex < fields.length) {
              const growthRate = data[fields[trendIndex]]
              const trend = this.getTrendInfo(growthRate)
              indicator.trendValue = trend.trendValue
              indicator.trendClass = trend.trendClass
              indicator.trendIcon = trend.trendIcon
            }
          })
        }
      } catch (error) {
        console.error('获取KPI关键指标失败:', error)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
$class-prefix: "rvc-cosmoplat-workspace-kpi-indicators";
.#{$class-prefix} {
  .indicators-container {
    display: grid;
    // flex-wrap: nowrap;
    grid-template-columns: repeat(2, 1fr);
    gap: 10px;
    height: 100%;
  }
  .indicator-item {
    flex: 1;
    // width: calc(100% / 7);
    display: flex;
    flex-direction: column;
    border-radius: 8px;
    background: #EFF2FC;
    // align-items: center;
    padding: 12px 16px;
    // border-right: 1px solid #f0f0f0;
    // &:last-child {
    //   border-right: none;
    // }
    .indicator-header {
      display: flex;
      flex-direction: column;
      // align-items: center;
      // justify-content: center;
      gap: 2px;
      margin-bottom: 8px;
    }
    .indicator-name {
      font-size: 12px;
      font-family: PingFangSC-Medium;
      font-weight: 600;
      font-size: 12px;
      color: #333333;
    }
    .indicator-trend {
      display: flex;
      align-items: center;
      gap: 4px;
      font-size: 12px;
      font-family: PingFangSC-Regular;
      font-weight: 400;
      &.trend-up {
        color: #73B950;
      }
      &.trend-down {
        color: #F44F4F;
      }
      &.trend-flat {
        color: #F4B13D;
      }
    }
    .trend-icon {
      font-size: 12px;
      font-weight: 900;
    }
    .trend-value {
      font-weight: 500;
    }
    .indicator-value {
      display: flex;
      align-items: baseline;
      gap: 8px;
    }
    .value-num {
      font-size: 24px;
      font-weight: 700;
      font-family: PingFangSC-Semibold;
      color: #333;
      line-height: 32px;
    }
    .value-unit {
      font-size: 12px;
      color: #333;
      font-weight: 400;
    }
  }
}
@media screen and (max-width: 1440px) {
  .#{$class-prefix} {
    .indicator-item {
      .value-num {
        font-size: 18px;
      }
      .indicator-name {
        font-size: 11px;
      }
    }
  }
}
</style>
